import React from 'react';
import { Quote, Star } from 'lucide-react';
import { TESTIMONIALS, PARTNERS } from '../mock';

const Testimonials = ({ lang }) => {
  const items = TESTIMONIALS[lang] || TESTIMONIALS.fr;
  return (
    <section className="relative py-24 bg-black border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Partners marquee */}
        <div className="mb-20">
          <p className="text-center text-xs tracking-[0.35em] text-zinc-500 mb-6 uppercase">
            {lang === 'fr' ? 'Réseau de transporteurs partenaires' : 'Trusted carrier network'}
          </p>
          <div className="overflow-hidden relative">
            <div className="flex gap-12 animate-[marquee_30s_linear_infinite] whitespace-nowrap">
              {[...PARTNERS, ...PARTNERS].map((p, i) => (
                <span
                  key={`${p}-${i < PARTNERS.length ? 'a' : 'b'}`}
                  className="text-zinc-500 hover:text-white text-xl font-bold tracking-wider transition-colors"
                >
                  {p}
                </span>
              ))}
            </div>
            <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-black to-transparent pointer-events-none" />
            <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-black to-transparent pointer-events-none" />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {items.map((it) => (
            <div
              key={it.author}
              className="relative rounded-2xl border border-white/10 bg-gradient-to-br from-white/[0.03] to-transparent p-7 hover:border-[#004aad]/40 transition-colors"
            >
              <Quote className="h-8 w-8 text-[#004aad] mb-4" />
              <p className="text-zinc-200 leading-relaxed mb-6">“{it.quote}”</p>
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-white font-semibold text-sm">{it.author}</div>
                  <div className="text-zinc-500 text-xs mt-0.5">{it.role}</div>
                </div>
                <div className="flex gap-0.5">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <Star key={s} className="h-3.5 w-3.5 fill-[#5b8def] text-[#5b8def]" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
